import * as React from "react";
import { Header, Icon, Grid, Container, Segment } from "semantic-ui-react";
import {withLayout} from "../components/Layout";

const RadiosPage = () => {
  return (
    <Container>
      <Segment vertical>
        <Header as="h2">
          <Icon name="wifi" />
          <Header.Content>
            Radios
          </Header.Content>
        </Header>
      </Segment>
      <Segment vertical>
        <p>
          <a href="https://meteorcomm.com/">Metorcomm</a> 
        </p>
      </Segment>
    </Container>
  );
};

export default withLayout(RadiosPage);
